import utils from 'Vue/Core/utils.js'
import c from 'Vue/Core/constants.js'


const CommonFunctionMixin = {
    methods: {
    createIframe(srcFile) {
        utils.GenerateFileURL(srcFile).then((url) => {
            var objFra = document.createElement('iframe');
            objFra.style.visibility = "hidden";   
            objFra.src = url;                  
            document.body.appendChild(objFra); 
            objFra.contentWindow.focus();    
            objFra.contentWindow.print();
        });
    },
    printSingleDoc(doc) {
        //Below code is commented as per the task:160247
        // let url = doc.replace(/^http:\/\//i, 'https://');
        // this.createIframe(url)

        this.previewSingleDoc(doc)
    },
    downloadSingleDoc(doc) {
        let d = doc + "&download=true";
        utils.GenerateFileURL(d).then((url) => {
            window.open(url, '_blank') 
        });
    },
    previewSingleDoc(doc) {
        utils.GenerateFileURL(doc).then((url) => {
            window.open(url, '_blank') 
        });
        //window.open(utils.getFilePreviewLink(doc),'_blank')
    },
  }
}
export default CommonFunctionMixin


// WEBPACK FOOTER //
// ./src/components/ESSProfile/Timesheets/CommonFunctionMixin.js